import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import * as getters from './getters';
import mutations from './mutations';
import actions from './actions';
import cities from './cities';

Vue.use(Vuex);

let state = {
    user: {},
    modal: {
        eventId: null,
        type: null,
        text: null
    },
    data: {
        tags: [],
        meta: {},
        content: {}
    },
    uploadFiles: [],
    documents: [],
    goals: [],
    year: moment().year(),
    audits: [],
    nonconformances: [],
    paymentMethods: [],
    siteId: null,
    sites: [],
    siteTypes: [],
    dataTypes: [],
    countryMap: {},
    regionMap: {},
    cityMap: {},
    sectorMap: {},
    locationMap: [],
    tagMap: [],
    scopeGroupMap: [],
    sourceTypeGroupMap: [],
    sourceTypeMap: [],
    unitMap: {},
    dashboardDataTypes: [121, 124, 147],
    formTypes: [],
    units: [],
    maxUpdatedAtForDocuments: null,
    maxUpdatedAtForGoals: null,
    maxUpdatedAtForAudits: null,
    cities: cities,
    siteGroups: [],
    isInitiated: false,
    isMobile: false,
    isTablet: false,
    locale: 'tr',
    // Need production ip address
    /*eslint-disable */
    apiURL: process.env.NODE_ENV === 'development' ? 'http://localhost:7788' : '/backend',
    token: `Bearer ${localStorage.getItem('token')}`
    /*eslint-enable */
};

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions: actions(Vue)
});



// WEBPACK FOOTER //
// ./src/store/index.js